export default __webpack_public_path__ + "static/media/291.fa1e3a23.jpg";